import React from 'react';
import { connect } from '../../../../redux/store';
import {
  ErrorMessage,
  EmptyMessage,
  LoadingMessage,
  C,
} from '@kineticdata/bundle-common';
import { I18n } from '@kineticdata/react';
import { DefaultActions } from './';
import { CONTENT_MANAGER_MODE } from '../helpers';
import { ServiceCard } from '../../ServiceCard';

const mapStateToProps = (state, props) => {
  const isPublicMode = props.mode === CONTENT_MANAGER_MODE.PUBLIC;
  const isViewMode = props.mode !== CONTENT_MANAGER_MODE.EDIT;
  const id = props.activeItem && props.activeItem.id;

  return {
    isPublicMode,
    isViewMode,
    id,
    services: (isPublicMode
      ? state.app.catalog.services
      : state.settingsService.dataList
    ).filter(s =>
      s.values[C.FIELD_PORTFOLIO_ID].includes(
        props.values.get(C.FIELD_PORTFOLIO_ID),
      ),
    ),
    servicesLoading: isPublicMode
      ? !state.app.catalog.init && state.app.catalog.loading
      : !state.settingsService.dataInit && state.settingsService.dataLoading,
    servicesError: isPublicMode
      ? state.app.catalog.errors.first()
      : state.settingsService.dataError,
  };
};

const PortfolioServicesRenderer = connect(mapStateToProps)(
  ({
    mode,
    isPublicMode,
    isViewMode,
    content,
    values,
    activeItem,
    id,
    services,
    servicesLoading,
    servicesError,
    ...props
  }) => {
    return !!activeItem ? (
      <>
        <h2>
          <I18n>{activeItem.title}</I18n>
        </h2>

        {!isViewMode && (
          <div className="form mb-3">
            <div className="form-group">
              <label htmlFor="title">
                <I18n>Section Title</I18n>
              </label>
              <input
                type="text"
                id="title"
                value={activeItem.title}
                onChange={props.handleContentChange(id, 'title')}
              />
            </div>

            <div className="form-group">
              <em>
                <I18n>
                  To add services to this portfolio, you must update the service
                  and relate it to this portfolio.
                </I18n>
              </em>
            </div>
          </div>
        )}

        {servicesError ? (
          <ErrorMessage
            title="The services failed to load."
            message={servicesError.message}
          />
        ) : servicesLoading ? (
          <LoadingMessage />
        ) : services.size === 0 ? (
          <EmptyMessage title="There are no services in this portfolio." />
        ) : (
          <div className="cards">
            {services.map(service => (
              <ServiceCard
                key={service.id}
                service={service}
                path={
                  isViewMode
                    ? `services/${service.values[C.FIELD_SERVICE_ID]}`
                    : undefined
                }
              />
            ))}
          </div>
        )}

        {!isViewMode && (
          <DefaultActions
            id={id}
            isDirty={activeItem.isDirty}
            handleResetSection={props.handleResetSection}
            handleContentDelete={props.handleContentDelete}
            actionsPending={props.actionsPending}
          />
        )}
      </>
    ) : null;
  },
);

// Metadata for this renderer
PortfolioServicesRenderer.ID = 'PORTFOLIO_SERVICES';
PortfolioServicesRenderer.NAME = 'Portfolio Services';
PortfolioServicesRenderer.TYPES = ['Portfolio'];

// Define fields managed by this section so we can know which fields to reset
// when the section is reset. Can store additional metadata for fields to use in
// the renderer above.
// PortfolioServicesRenderer.FIELDS = {};

export default PortfolioServicesRenderer;
